var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"display":"inline-block"}},[_c('v-img',{attrs:{"src":_vm.emoji,"width":_vm.size,"height":_vm.size}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }